'use client'

import * as CookieConsent from 'vanilla-cookieconsent'
import { Button, type ButtonProps } from './ui/button'

type Props = ButtonProps

export function CookiePreferenceButton({ onClick, ...props }: Props) {
  return <Button onClick={() => CookieConsent.showPreferences()} {...props} />
}
